<template>
  <transition name="fade">
    <div class="Dialog" ref="Dialog" v-if="dialogVisible">
      <div class="bg" @click="maskClick"></div>
      <div class="content" :style="`width: ${width}px;`">
        <div class="title">
          {{title}}
        </div>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>
<script>
  export default {
    name: 'Dialog',
    props: {
      dialogShow: {
        type: Boolean,
        default() {
          return false
        },
      },
      title: {
        type: String,
        default() {
          return ''
        },
      },
      maskClose: {
        type: Boolean,
        default() {
          return true
        },
      },
      width: {
        type: String,
        default() {
          return '550'
        },
      }
    },
    data() {
      return {
        dialogVisible: false
      }
    },
    created () {
      this.dialogVisible = this.dialogShow
    },
    methods: {
      maskClick () {
        if (!this.maskClose) return
        this.$emit('maskClick', false)
        this.dialogVisible = false
      },
    },
    computed: {
    },
    components: {
    },
    watch: {
      dialogShow () {
        this.dialogVisible = this.dialogShow
      },
      maskClose (n) {
        this.maskClose = n
      }
    }
  }
</script>
<style lang="scss" scoped>
  .Dialog{
  height: 100vh;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  .bg{
    opacity: 0.5;
    height: 100vh;
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  .content{
    background: #fff;
    width: 550px;
    min-height: 320px;
    z-index: 99;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;
    padding: 30px;
    .title{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      height: 42px;
      border-bottom: 1px solid #ccc;
    }
  }
}
.fade-leave,   // 离开前,进入后透明度是1
.fade-enter-to {
  opacity: 1;
}
.fade-leave-active,
.fade-enter-active {
  transition: all .5s; //过度是2秒
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
</style>
